/**
 * Used to describe the direction of an action. For example, clicking the next or previous arrows on the date strip.
 */
export default Object.freeze({
  previous: 'previous',
  next: 'next',
})
